import { VoicemailData } from "@services/dataClasses/VoicemailData";

export const SELECT_VOICEMAIL_ITEMS = "SELECT_VOICEMAIL_ITEMS";

export const setSelectedVoicemails = (payload: VoicemailData[]) => ({
  type: SELECT_VOICEMAIL_ITEMS,
  payload,
});
